export const backLabel = `Voltar`;
export const clearLabel = `Limpar tudo`;
export const filterLabel = `Filtrar`;